import type { NavigationMenuItem } from "@nuxt/ui"

import { ICON } from "@/lib/icons"
import {
  batchesPath,
  capturePath,
  containersPath,
  inventoryExportsPath,
  inventoryIndexPath,
  itemTypesPath,
  itemsPath,
  loansPath,
  outingsPath,
  peoplePath,
  printPath,
  rootPath,
  tagsPath,
} from "@/routes"

export function buildDefaultNavigationLinks(onSelect: () => void): NavigationMenuItem[][] {
  return [
    [
      { label: "Inventory", type: "label" },
      { label: "Dashboard", icon: ICON.home, to: rootPath(), exact: true, onSelect },
      { label: "Items", icon: ICON.item, to: itemsPath(), onSelect },
      { label: "Containers", icon: ICON.container, to: containersPath(), onSelect },
      {
        label: "Inventory Progress",
        icon: ICON.inventoryProgress,
        to: inventoryIndexPath(),
        onSelect,
      },
      { label: "Batches", icon: ICON.batches, to: batchesPath(), onSelect },
    ],
    [
      { label: "Organize", type: "label" },
      { label: "Tags", icon: ICON.tag, to: tagsPath(), onSelect },
      { label: "Types", icon: ICON.itemType, to: itemTypesPath(), onSelect },
      { label: "People", icon: ICON.people, to: peoplePath(), onSelect },
      { label: "Loans", icon: ICON.loan, to: loansPath(), onSelect },
      { label: "Outings", icon: ICON.outing, to: outingsPath(), onSelect },
    ],
    [
      { label: "Tools", type: "label" },
      { label: "Capture", icon: ICON.capture, to: capturePath(), onSelect },
      { label: "Print", icon: ICON.print, to: printPath(), onSelect },
      {
        label: "Import / Export",
        icon: ICON.importExport,
        to: inventoryExportsPath(),
        onSelect,
      },
    ],
  ]
}
